import { render, staticRenderFns } from "./classify.vue?vue&type=template&id=5ff2f157&scoped=true&"
import script from "./classify.vue?vue&type=script&lang=js&"
export * from "./classify.vue?vue&type=script&lang=js&"
import style0 from "./classify.vue?vue&type=style&index=0&id=5ff2f157&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff2f157",
  null
  
)

export default component.exports